import * as angular from 'angular';

import { PropertyType, GroupConfigMode, Group } from '../../../models/index';
import * as Fields from '../../../common/helpers/contextual';

export function getManualInputProperties(currentGroup: Group, manualGroups: Group[]) {

    const groupProperty = {
        modelName: 'group',
        propertyType: PropertyType.Group,
        label: 'Group',
        propertyName: 'groupProperty',
        required: false,
        icon: 'fa-sitemap',
        extraData: {
            groups: getSelectableGroups(manualGroups)
        }
    };
    const isBoundProperty = {
        modelName: 'isBound',
        propertyType: PropertyType.Boolean,
        label: 'Bind',
        placeholder: 'Bind',
        propertyName: 'isBoundProperty',
        required: false,
        icon: 'fa-link',
        onChange: (viewValue: boolean) => {
            groupProperty.extraData.groups = getSelectableGroups(manualGroups);
        }
    };

    const tagNameProperty = angular.copy(Fields.NameConfiguration.HasName);
    tagNameProperty.icon = 'fa-tag';
    tagNameProperty.label = 'Tag name';
    tagNameProperty.placeholder = tagNameProperty.label;

    const identifierNameProperty = angular.copy(Fields.NameConfiguration.HasName);
    identifierNameProperty.modelName = 'hasIdentifierName';
    identifierNameProperty.propertyName = 'hasIdentifierNameProperty';

    const properties = [
        angular.copy(Fields.IsVertical),
        groupProperty,
        angular.copy(Fields.IncludeChildren),
        {
            modelName: 'identifierQueries',
            propertyType: PropertyType.Queries,
            label: 'Filter by queries',
            placeholder: 'Filter by queries',
            propertyName: 'identifierQueriesProperty',
            required: false,
            icon: 'fa-filter'
        },
        angular.copy(Fields.MaxColumns),
        angular.copy(Fields.DateFormat),
        angular.copy(Fields.ValueFieldWidth),
        angular.copy(Fields.NameConfiguration.HasGroupName),
        identifierNameProperty,
        tagNameProperty,
        angular.copy(Fields.NameConfiguration.HasShortComment),
        angular.copy(Fields.NameConfiguration.HasUnit),
        angular.copy(Fields.Decimals),
        angular.copy(Fields.AllowLogbookEntries),
        {
            modelName: 'showMissingWarnings',
            propertyType: PropertyType.Boolean,
            label: 'Show warnings for empty cells',
            placeholder: 'Show warnings for empty cells',
            propertyName: 'showMissingWarningsProperty',
            required: false,
            icon: 'fa-exclamation-triangle'
        },
        angular.copy(Fields.LaunchTask),
        angular.copy(Fields.IsDependentGroupsIncluded),
        {
            modelName: 'enableApproval',
            propertyType: PropertyType.Boolean,
            label: 'Enable approval',
            placeholder: 'Enable approval',
            propertyName: 'enableApprovalProperty',
            required: false,
            icon: 'fa-thumbs-o-up'
        }
    ];
    if (currentGroup.configMode === GroupConfigMode.ByType) {
        properties.splice(1, 0, isBoundProperty);
    }
    return properties;
}

function getSelectableGroups(manualGroups: Group[]): { guid: string; uniqueName: string }[] {
    return [{ guid: null, uniqueName: 'Current group' }, ...manualGroups];
}